import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";

import {
  Paper,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Button,
  Tooltip,
} from "@material-ui/core";

import * as icons from "@material-ui/icons";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

const Tabel = ({ rows, handleRemove, handleEdit }) => {
  const classes = useStyles();
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell align="left">Title</StyledTableCell>
            {/* <StyledTableCell align="left">Price</StyledTableCell> */}
            <StyledTableCell align="right"></StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, idx) => (
            <StyledTableRow key={idx}>
              <StyledTableCell align="left">
                <div>{row.title}</div>
              </StyledTableCell>
              {/* <StyledTableCell align="left">
                <div>{row.price}</div>
              </StyledTableCell> */}
              <StyledTableCell align="right">
                <div>
                  <Tooltip title="Edit">
                    <Button
                      className="p-0"
                      onClick={() => {
                        handleEdit(idx, row);
                      }}
                    >
                      <icons.EditOutlined style={{ color: "#0abde3" }} />
                    </Button>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <Button
                      className="p-0"
                      onClick={() => {
                        handleRemove(idx, row.title);
                      }}
                    >
                      <icons.DeleteOutline className="text-danger" />
                    </Button>
                  </Tooltip>
                </div>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Tabel;
